import React from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import servicesImg from "./../../assets/services/services.png"

import icon_1 from "./../../assets/icons/serv_icon_1.png"
import icon_2 from "./../../assets/icons/serv_icon_2.png"
import icon_3 from "./../../assets/icons/serv_icon_3.png"
import icon_4 from "./../../assets/icons/serv_icon_4.png"
import icon_5 from "./../../assets/icons/serv_icon_5.png"
import icon_6 from "./../../assets/icons/serv_icon_6.png"

import image3 from "./../../assets/services/Image.png"

import icon1 from "./../../assets/services/Icon.svg"
import icon2 from "./../../assets/services/Sheild Icon.svg"
import icon3 from "./../../assets/services/Environment Icon.svg"

const Services = () => {
    return (
        <div className="services">
            <div className="section_1 min-h-[50vh] bg-cover bg-no-repeat" style={{ backgroundImage: `url("${servicesImg}")` }}>
                <div className="layer bg-gradient-to-r min-h-[50vh] from-main-light to-transparent flex items-center justify-content ">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 m-auto  w-5/6 lg:w-4/6">
                        <span className="bg-dark-navy bg-opacity-50 text-white p-1 px-2 border-l-4 border-l-cyan text-sm ">Services</span>
                        <h2 className="text-3xl md:text-6xl text-white font-semibold my-3">Our Technology Services</h2>
                    </motion.div>
                </div>
            </div>
            <div className="section_2 services py-20">
                <div className="w-5/6 lg:w-4/6 m-auto">
                    <div className="header text-center">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-gold text-sm ">What We Do</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">Our Technology Services</h2>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_1} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 1</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.3,
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_2} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 2</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.6,
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_3} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 3</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 0.9
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_4} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 4</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 1.2
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_5} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 5</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                        <motion.div
                            initial={{
                                y: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.3,
                                delay: 1.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 p-4">
                            <div className="icon py-5">
                                <img src={icon_6} alt="" />
                            </div>
                            <h5 className="text-xl text-dark">Service 6</h5>
                            <p className='font-Krub font-medium text-sm text-gray my-3'>Following the quality of our service thus having gained trust of our many clients.</p>
                        </motion.div>
                    </div>
                    <div className="w-full text-center mt-10">
                        <Link to="/projects" className='bg-main-light w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11 mt-2'>More Work</Link>
                    </div>
                </div>
            </div>
            <div className="section_3 services bg-light py-20">
                <div className="w-5/6 lg:w-4/6 m-auto">
                    <div className="header text-center">
                        <span className="bg-gray-light bg-opacity-50 text-dark p-1 px-2 border-l-4 border-l-main-light text-sm ">Our Goodness</span>
                        <h2 className="text-3xl md:text-3xl text-dark font-semibold my-3">How We Works</h2>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                        <motion.div
                            initial={{
                                x: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1">
                            <img src={image3} alt="" />
                        </motion.div>
                        <motion.div
                            initial={{
                                x: 200,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 grid gap-5">
                            <div className="phone flex justify-start gap-5 ">
                                <div className="rounded-full">
                                    <img src={icon1} alt="" />
                                </div>
                                <div className="">
                                    <p className='text-2xl font-medium text-dark'>Integrated System</p>
                                    <span className="text-sm text-gray font-Krub font-medium">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking </span>
                                </div>
                            </div>
                            <div className="phone flex justify-start gap-5">
                                <div className="">
                                    <img src={icon2} alt="" />
                                </div>
                                <div className="">
                                    <p className='text-2xl font-medium text-dark'>Safety & Quality</p>
                                    <span className="text-sm text-gray font-Krub font-medium">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking </span>
                                </div>
                            </div>
                            <div className="phone flex justify-start gap-5">
                                <div className="">
                                    <img src={icon3} alt="" />
                                </div>
                                <div className="">
                                    <p className='text-2xl font-medium text-dark'>Care for Environment</p>
                                    <span className="text-sm text-gray font-Krub font-medium">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking </span>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services